export default __webpack_public_path__ + "static/media/home-img2.983b234b.png";